document.addEventListener("DOMContentLoaded", (event) => {
  document.getElementById("lang_mode")?.addEventListener("change", function (e) {
    e.preventDefault();
    changeFormLanguage(this);
  });

  function changeFormLanguage(ele) {
    const iframeContainer = document.getElementById("iframeContainer");
    const formSection = document.querySelector(".pre-approval-form-section");
    if (ele.checked) {
      iframeContainer.innerHTML = iframe2;
      runOtherLanguageFunction();
      formSection.classList.add("second--language");
      document.body.classList.remove("first--language");
    } else {
      iframeContainer.innerHTML = iframe1;
      runFirstLanguageFunction();
      formSection.classList.add("first--language");
      document.body.classList.remove("second--language");
    }

    // Re-attach the script to ensure it runs
    const script = document.createElement("script");
    script.src = form_script;
    document.body.appendChild(script);
  }

  // document
  //   .getElementById("translationButton")
  //   .addEventListener("click", function () {
  //     const iframeContainer = document.getElementById("iframeContainer");
  //     const button = document.getElementById("translationButton");
  //     const isEnglish = button.innerText === language2;

  //     // Set the iframe source based on the language
  //     iframeContainer.innerHTML = isEnglish ? iframe2 : iframe1;

  //     // Update the button text
  //     button.innerText = isEnglish ? language1 : language2;

  //     // Re-attach the script to ensure it runs
  //     const script = document.createElement("script");
  //     script.src = form_script;
  //     document.body.appendChild(script);

  //     // Run specific functions based on the language
  //     if (isEnglish) {
  //       runOtherLanguageFunction();
  //     } else {
  //       runFirstLanguageFunction();
  //     }
  //   });

  function toggleVisibility(sectionClass, elementClass, targetId) {
    const containers = document.querySelectorAll(
      `${sectionClass} ${elementClass}`
    );

    if (containers.length === 0) {
      console.warn(
        `No elements found for ${elementClass} inside ${sectionClass}.`
      );
      return;
    }

    containers.forEach((container) => {
      if (container.id === targetId) {
        container.classList.remove("hidden");
      } else {
        container.classList.add("hidden");
      }
    });
  }

  function runFirstLanguageFunction() {
    toggleVisibility(
      ".pre-approval-form-section",
      ".title-container",
      "title-first-language"
    );
    toggleVisibility(
      ".pre-approval-form-section",
      ".description-container",
      "desc-first-language"
    );
  }

  function runOtherLanguageFunction() {
    toggleVisibility(
      ".pre-approval-form-section",
      ".title-container",
      "title-second-language"
    );
    toggleVisibility(
      ".pre-approval-form-section",
      ".description-container",
      "desc-second-language"
    );
  }
});
